import cookie from 'utilities/cookie';
import { actions as mainActions } from '../config/reduxIndex';
import svc from 'svc';


export const types = {
	SET_DEFAULT: 'LOGIN/SET_DEFAULT',
	SET_STATE: 'LOGIN/SET_STATE',
	SET_ATTRIBUTE: 'LOGIN/SET_ATTRIBUTE',
	SET_ATTRIBUTE_BY_OBJ: 'LOGIN/SET_ATTRIBUTE_BY_OBJ',
};

const defaultState = {
	requiresLogin: true,
	changePass: false,
	pending: false,
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case types.SET_DEFAULT:
			return {...defaultState};
		case types.SET_STATE:
			return {...state, ...action.data};
		case types.SET_ATTRIBUTE:
			return Object.assign({}, state, { [action.attr]: action.value });
		case types.SET_ATTRIBUTE_BY_OBJ:
			return Object.assign({}, state, action.obj);
		default:
			return state;
	}
}

export const actions = {
	setDefault: () => {
		return { type: types.SET_DEFAULT };
	},
	setState: (data) => ({type: types.SET_STATE, data}),
	setAttribute: (attr, value) => {
		return {
			type: types.SET_ATTRIBUTE,
			attr,
			value,
		}
	},
	setAttributeByObj: (obj) => {
		return {
			type: types.SET_ATTRIBUTE_BY_OBJ,
			obj,
		}
	},
	logout: () => {
		return function (dispatch) {
			cookie.remove('session', {path: '/'});
			cookie.remove('currentUser', {path: '/'});
			svc.close();
			dispatch(actions.setAttribute('requiresLogin', true));
			dispatch(mainActions.globalState.addNotice('Successfully Logged Out'));
			dispatch(mainActions.routing.setRoute('/'));
		}
	},
	loginSubmit: (submitObj) => {
		return function (dispatch, getState) {
			const changePass = getState().login.changePass;
			let loginObj = {
				'user': submitObj.username,
				'pass': submitObj.password,
			};
			if (changePass === true) {
				loginObj['password1'] = submitObj.password1;
				loginObj['password2'] = submitObj.password2;
			}
			svc.send('auth', loginObj).then((res) => {
				cookie.set('session', res['payload'], {path: '/'});

				if (res.payload.hasOwnProperty('dispatchUserType')) {
					cookie.set('userType', res.payload.dispatchUserType, {path: '/'});
				}

				if (res.payload.hasOwnProperty('empID')) {
					cookie.set('empID', res.payload.empID, {path: '/'});
				}

				if (res.payload.hasOwnProperty('userID')) {
					cookie.set('userID', res.payload.userID, {path: '/'});
				}

				cookie.set('requiresRelog', false, {path: '/'});
				cookie.set('currentUser', submitObj.username, {path: '/'});
				const changeObj = {
					requiresLogin: false,
					changePass: false,
				};
				dispatch(actions.setAttributeByObj(changeObj));
				if (submitObj.changePass === true) {
					dispatch(mainActions.globalState.addSuccess('Successfully Changed Password and Logged in'));
				} else {
					dispatch(mainActions.globalState.addSuccess('Successfully Logged in'));
				}
				//dispatch(actions.setDefault()); // IMPORTANT
				if (submitObj.defaultRoutePostLogin === true) {
					//dispatch(mainActions.routing.setRoute('/home/'));
				}
			}).catch(function (err) {
				let errorMsg = err.msg;
				if (typeof err === 'string') {
					errorMsg = err;
				}
				if (err.status === 403) {
					dispatch(actions.setAttribute('changePass', true));
				}
				dispatch(mainActions.globalState.addError(errorMsg));
			});
		}
	},
};


// WEBPACK FOOTER //
// ./src/redux/login.js